import Vue from 'vue'
import Vuex from 'vuex'

import { alert } from './alert.module'
import { account } from './account.module'
import { users } from './users.module'
import { dogs } from './dogs.module'
import { phones } from './phones.module'
import { miscellaneous } from './miscellaneous.module'
import { canines } from './canines.module'
import { expos } from './expos.module'
import { expoTarifas } from './expo.tarifas.module'
import { expoPasarelas } from './expo.pasarelas.module'
import { inscriptions } from './inscriptions.module'
import { expoDocs } from './expo.docs.module'


Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    alert,
    account,
    users,
    dogs,
    phones,
    miscellaneous,
    canines,
    expos,
    expoTarifas,
    expoPasarelas,
    inscriptions,
    expoDocs
  },
  strict: true
})
